import { Component, Input } from '@angular/core';

@Component({
  selector: 'export-progress-dialog',
  template: `
    <p-dialog
      [header]="'EXPORT_IN_PROGRESS' | translate"
      [(visible)]="visible"
      [modal]="true"
      [closable]="false"
      [dismissableMask]="false"
      [style]="{ width: '400px', maxWidth: 'calc(100vw - 2rem)' }"
    >
      <div class="export-progress" role="status" aria-live="polite">
        <i class="pi pi-spinner pi-spin" aria-hidden="true"></i>
        <p>{{ 'EXPORT_IN_PROGRESS_DESCRIPTION' | translate }}</p>
      </div>
    </p-dialog>
  `,
  styles: [
    `
      .export-progress {
        text-align: center;
        padding: var(--kuba-space-4);
      }
      .export-progress .pi {
        font-size: 2rem;
        color: var(--p-primary-color);
      }
      .export-progress p {
        margin: var(--kuba-space-4) 0 0;
        color: var(--p-text-color);
      }
      @media (prefers-reduced-motion: reduce) {
        .pi-spin {
          animation: none;
        }
      }
    `
  ],
  standalone: false
})
export class ExportProgressDialogComponent {
  @Input() visible = false;
}
